<!-- <video [@videoAnimation] width="100%" autoplay id="video">
    <source src="http://video.diaabie.com/Martian_immigrants_20180504_converted.mp4" type="video/mp4">
</video> -->
<!--
  <div id="video">
  </div>
 -->
<div [@videoAnimation] id="videoWrap" *ngIf="showVideo">
	<div id="video" [ngClass]="{'pcVideo':isPC}" *ngIf="showVideo">
	</div>
	<img src="{{assetsRoute}}/picture/casepracticeteam/bg.png" id="videoShortCut">
	<div id="closeBtn" (tap)="closeVideo()" (click)="closeVideo()" *ngIf="showCloseBtn">
		<span >×</span>
  	</div>
</div >

<!-- <div id="videoHover"></div>
<img src="{{assetsRoute}}/picture/casepracticeteam/bg.png" id="videoShortCut">
 -->



// WEBPACK FOOTER //
// ./src/app/case-practice-team-video/case-practice-team-video.component.html